import axios, { AxiosResponse } from 'axios';

import { ELeiStavZadosti } from 'enums/lei/leiStavZadosti';
import { ETypZadosti } from 'enums/lei/leiTypZadosti';

import { ILeiInfo } from './PrehledUctu';

export interface ILeiZadost {
    datumpodani: string;
    stav: ELeiStavZadosti;
    idzadosti: number;
    typzadosti: ETypZadosti;
}

export interface ILeiPrehledZadosti {
    offset: number;
    limit: number;
    count: number;
    order: string;
    token: string;
    lei: ILeiZadost[];
    leidetail: ILeiInfo;
}

const leiZadostiApi = (varsym: string) => {
    return axios({
        method: 'GET',
        url: `LEI/${varsym}/zadosti/`
    }).then((resp: AxiosResponse<ILeiPrehledZadosti>) => resp.data);
};

export default leiZadostiApi;
